import Main from './main.webp';
import News from './news.webp';
import Stonks10 from './stonks10.webp';
import StonksOtherMenu from './stonksothermenu.webp';

export default {
    Main,
    News,
    Stonks10,
    StonksOtherMenu
}